import { defineStore } from "pinia";
import type { WebflowArticle } from "@/types/webflow";
import config from "../config";

export const useWebflowStore = defineStore("webflow", {
  state: () => ({
    articles: [] as WebflowArticle[],
  }),
  actions: {
    async fetchArticles(
      query: ComputedRef<Object>,
    ): Promise<{ pending: globalThis.Ref<boolean> }> {
      const { pending } = await useFetch<WebflowArticle>(
        `${config("apiBaseUrl")}/webflow`,
        {
          query: {
            tags: Object.values(query.value).join(","),
          },
          key: `pros/${JSON.stringify(query.value)}`,
          watch: [() => query],
          onResponse: ({ response }) => {
            this.articles = response._data || [];
          },
        },
      );

      return { pending };
    },
  },
});
